<template>
  <section class="section-base form-section-base">
    <div class="form-section-base__title">Описание электронного документа</div>

    <v-container>
      <div class="form-base">
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model.trim="$v.conversionDocument.name.$model"
              :errorMessages="
                getValidationErrorText($v.conversionDocument.name)
              "
              label="Наименование файла"
              outlined
            />
          </v-col>
        </v-row>

        <AttachDocumentSingle
          @change="
            $v.conversionDocument.file.$model = $event.file;
            $v.conversionDocument.fileSig.$model = $event.fileSig;
          "
          :value="{
            file: $v.conversionDocument.file.$model,
            fileSig: $v.conversionDocument.fileSig.$model,
          }"
          :error-messages="getValidationErrorText($v.conversionDocument.file)"
          :acceptFile="['.tif', '.tiff']"
        />
      </div>

      <Footer
        @next-btn-click="btnSaveClickHandler(StepDirection.NEXT)"
        @prev-btn-click="btnSaveClickHandler(StepDirection.PREV)"
        :loading-next="loadingNext"
      />
    </v-container>
  </section>
</template>

<script>
import cloneDeep from 'clone-deep';
import { maxLength, required } from 'vuelidate/lib/validators';

import { getValidationErrorText, EMOJI } from '@/utils/validate';
import Footer from '@/components/services/elements/Footer';
import AttachDocumentSingle from '@/components/base/AttachDocument/AttachDocumentSingle';
import { checkInvalid, leaveStep } from '@/utils/services';
import { ServicesModule } from '@/store/modules/services';
import { StepDirection, StepName } from '@/types/services';
import { DocumentConversionStep } from '@/constants';

export default {
  name: 'ConversionDocument',
  props: {
    loadingNext: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    Footer,
    AttachDocumentSingle,
  },
  data: () => ({
    StepDirection,
    StepName,
    leaveStep,
    getValidationErrorText,
    invalidFields: [],
    conversionDocument: {
      name: '',
      file: null,
      fileSig: null,
    },
  }),
  validations: {
    conversionDocument: {
      name: {
        required,
        maxLength: maxLength(255),
        EMOJI,
      },
      file: {
        DOCUMENTS_MIN_LENGTH: required,
      },
      fileSig: {
        DOCUMENTS_MIN_LENGTH: required,
      },
    },
  },
  created() {
    this.prefillDraft();
  },
  methods: {
    prefillDraft() {
      if (!ServicesModule.statement.conversionDocument) {
        return;
      }

      this.conversionDocument = cloneDeep(
        ServicesModule.statement.conversionDocument
      );
    },

    assemblyModel() {
      return cloneDeep(this.conversionDocument);
    },

    touchFields() {
      this.invalidFields = [];

      this.$v.$touch();
      checkInvalid(this.$v, this.invalidFields);
    },

    btnSaveClickHandler(direction) {
      leaveStep({
        stepThis: this,
        direction,
        step: DocumentConversionStep.CONVERSION_DOCUMENT,
      });
    },
  },
};
</script>
